import { api } from "@/lib/api";
import { trackLead } from "@/lib/analytics";

// Anonymous learners take the quiz first; we stash their answers and submit them
// the moment they create an account / log in.
const KEY = "aip_pending_quiz";

export const savePendingQuiz = (answers) => {
  try { localStorage.setItem(KEY, JSON.stringify(answers)); } catch { /* ignore */ }
};

export const getPendingQuiz = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "null"); } catch { return null; }
};

export const clearPendingQuiz = () => {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
};

// Submits a stashed quiz (if any) right after auth. Returns the answers on success.
export async function submitPendingQuiz() {
  const answers = getPendingQuiz();
  if (!answers) return null;
  try {
    await api.post("/quiz/submit", answers);
    clearPendingQuiz();
    trackLead();
    return answers;
  } catch {
    return null;
  }
}
